export enum TypeGeneralWidget {
  AIRLINES_WIDGET = 'AIRLINES_WIDGET',
  DEPARTURE_WIDGET = 'DEPARTURE_WIDGET',
  DEPARTURE_WIDGET_RETURN = 'DEPARTURE_WIDGET_RETURN',
  REFUNDABLE_WIDGET = 'REFUNDABLE_WIDGET',
  STARS_WIDGET = 'STARS_WIDGET',
  AMMENITIES_WIDGET = 'AMMENITIES_WIDGET',
  PRICE_WIDGET = 'PRICE_WIDGET',
  ALERTS_WIDGET = 'ALERTS_WIDGET'
}
